module.exports = __webpack_public_path__ + "static/media/05.firefox.57cfc798.svg";